import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useSession } from "@/services/auth0/session";
import { ShippingOptionsResponse } from "@/api.types";

interface GetShippingOptionsParams {
  pickupAddress: {
    location: { lat: number; lng: number };
    postalCode: string;
  };
  deliveryAddress: {
    location: { lat: number; lng: number };
    postalCode: string;
  };
  parcels: {
    weight: number;
    dimensions?: {
      length: number;
      width: number;
      height: number;
    };
  }[];
  specialHandlingTypes: string[];
  customerTierId?: string;
}

export function useGetShippingOptions() {
  const { token } = useSession();

  return useMutation<ShippingOptionsResponse, Error, GetShippingOptionsParams>({
    mutationFn: async (params) => {
      const { data } = await axios.post<ShippingOptionsResponse>(
        `${import.meta.env.VITE_API_URL}/api/v1/pricing/shipping-options`,
        params,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return data;
    },
  });
}
